import { render, staticRenderFns } from "./TablatureBar.vue?vue&type=template&id=1f903287&scoped=true"
import script from "./TablatureBar.vue?vue&type=script&lang=js"
export * from "./TablatureBar.vue?vue&type=script&lang=js"
import style0 from "./TablatureBar.vue?vue&type=style&index=0&id=1f903287&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f903287",
  null
  
)

export default component.exports